<template>
  <footer class="footer">
    <!-- todo get data from prismic -->
    <div class="footer-content container">
      <div class="footer-content__column">
        <strong>Links</strong>
        <a v-for="link in fields.leftColumnLinks"
             :key="link.link_text"
             :href="link.link.url ? link.link.url : link.anchor_link"
          >
            {{ link.link_text }}
          </a>
      </div>
      <div class="footer-content__column">
        <prismic-rich-text v-if="fields.rightColumnText" :field="fields.rightColumnText"/>
      </div>
      <div class="footer-content__column">
        <div class="footer-content__weather-list" v-if="weatherForecast">
          <div class="footer-content__weather-list-item"
               v-for="(weatherDay, index) in weatherForecast"
               :key="weatherDay.dt"
          >
          <span v-if="index == 0">
            {{ KriensTourismus.languageKeys['today'] }}: 
          </span>
          <span v-else>
            {{ getDateString(weatherDay.dt) }}: 
          </span>
          <img :src="iconBaseUrl + weatherDay.weather[0].icon + '.png'" />
          {{ Math.round(weatherDay.temp.max) }} &#8451;
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright container">
      <span>&copy;Kriens-Tourismus, {{ year }}</span>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import EventBus from '../EventBus.js'
import DateUtils from '../utils/DateUtils.js'

export default {
  name: 'PageFooter',
  props: ['Sight'],
  data () {
    return {
      openWeatherApiKey: '8397e7df91f99b4c9ba0f46646528482', // actual key: todo repalce with '3455682ac0087dbc598ef83ab33d7fe6',
      kriensCityCode: '7286225',
      iconBaseUrl: 'https://openweathermap.org/img/wn/',
      weatherForecast: null,
      fields: {
        leftColumnLinks: null,
        rightColumnText: null
      }
    }
  },
  computed: {
    year () {
      return (new Date()).getFullYear()
    }
  },
  created () {
    this.getWeatherForecast()
    this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
  methods: {
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('footer', {lang: language})
      if (document) {
        this.fields.leftColumnLinks = document.data.left_column_links
        this.fields.rightColumnText = document.data.right_column
      }
    },
    async getWeatherForecast () {
      let response = await axios.get('//api.openweathermap.org/data/2.5/forecast/daily?cnt=5&units=metric&appid=' + this.openWeatherApiKey + '&id=' + this.kriensCityCode)
      if (response) {
        this.weatherForecast = response.data.list
      }
    },
    getDateString (timestamp) {
      let date = new Date(timestamp * 1000)
      let day = DateUtils.days[window.KriensTourismus.language][date.getDay()]
      return day
    }
  }
}
</script>